/** @flow */

import type { HierarchyChangelogState } from "./types";

export const initialState: HierarchyChangelogState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  users: [],
};

export default initialState;
